'use strict';

module.exports = locate;

function locate(value, fromIndex) {
  return value.indexOf('\\', fromIndex);
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-parse/lib/locate/escape.js
// module id = 1361
// module chunks = 0